// Lightweight client-side preferences for weak-network / privacy features.
const emit = () => { try { window.dispatchEvent(new Event("rc-prefs")); } catch {} };

export const ultraLiteOn = () => localStorage.getItem("rc_ultra_lite") === "1";
export const setUltraLite = (on) => { localStorage.setItem("rc_ultra_lite", on ? "1" : "0"); emit(); };

export const hidePreviewsOn = () => localStorage.getItem("rc_hide_previews") === "1";
export const setHidePreviews = (on) => { localStorage.setItem("rc_hide_previews", on ? "1" : "0"); emit(); };

export const mediaTTLDays = () => parseInt(localStorage.getItem("rc_media_ttl") || "0", 10);
export const setMediaTTLDays = (d) => { localStorage.setItem("rc_media_ttl", String(d)); emit(); };
